import { useState, useEffect } from 'react';
// @mui
import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';

// --- АНІМАЦІЇ ---

const spin = keyframes`
  0% { transform: translateX(-50%) rotate(0deg); }
  100% { transform: translateX(-50%) rotate(360deg); }
`;

const floatHorizontal = keyframes`
  0% { transform: translateX(0px); }
  100% { transform: translateX(40px); }
`;

// --- КОМПОНЕНТ ---

export default function BackgroundDecorations() {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (event) => {
      const x = (window.innerWidth / 2 - event.clientX) / 60;
      const y = (window.innerHeight / 2 - event.clientY) / 60;
      setMousePos({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      {/* 1. БУБЛИК (SVG) */}
      <Box
        sx={{
          position: 'absolute',
          top: '100px',
          left: '50%',
          width: '180px',
          height: '180px',
          animation: `${spin} 25s linear infinite`,
        }}
      >
        <svg viewBox="0 0 100 100" width="100%" height="100%" fill="none" style={{ overflow: 'visible' }}>
          <path
            d="M 35 80 A 35 35 0 1 1 35 20"
            stroke="#FFD600" 
            strokeWidth="28"
            strokeLinecap="butt"
          />
          <circle cx="35" cy="20" r="14" fill="#FBC02D" />
          <circle cx="35" cy="80" r="14" fill="#FBC02D" />
        </svg>
      </Box>

      {/* 2. Жовтий статичний круг (Верхній лівий) */}
      <Box
        sx={{
          position: 'absolute',
          top: '-150px',
          left: '-150px',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          bgcolor: '#FFD600',
        }}
      />

      {/* 3. Жовтий великий круг (Центральний нижній) */}
      <Box
        sx={{
          position: 'absolute',
          top: '65%',
          left: '30%',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          bgcolor: '#FFF59D',
          transform: 'translate(-50%, -50%)',
        }}
      />

      {/* 4. ВЕЛИЧЕЗНИЙ Помаранчевий круг (Справа) */}
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          right: '-250px',
          width: '650px',
          height: '650px',
          borderRadius: '50%',
          bgcolor: '#FFE0B2',
          transform: `translate(${mousePos.x}px, ${mousePos.y}px)`,
          transition: 'transform 0.4s ease-out',
        }}
      />

      {/* 5. Маленький жовтий кружечок */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '50px',
          left: '50%', 
          marginLeft: '-220px', 
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          bgcolor: '#FFEE58',
          animation: `${floatHorizontal} 4s ease-in-out infinite alternate`,
        }}
      />

      {/* 6. Довгий помаранчевий овал (НАПІВПРОЗОРИЙ) */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '50px',
          left: '50%',
          marginLeft: '-140px',
          width: '350px',
          height: '60px',
          borderRadius: '30px', 
          bgcolor: '#FF7043',
          opacity: 0.5, // <--- Додав прозорість
          animation: `${floatHorizontal} 4s ease-in-out infinite alternate`,
        }}
      />
    </Box>
  );
}